import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const SITE_NAME = "Infokarta d.o.o.";
const SITE_URL = "https://www.infokarta.hr";
const DEFAULT_TITLE = "Infokarta d.o.o. — Geodetski ured Split | Geodezija, GIS, LiDAR";
const DEFAULT_DESC =
  "Geodetski ured Infokarta iz Splita — katastarski premjer, legalizacija, kartografija, inženjerska geodezija, LiDAR i GIS rješenja za cijelu Dalmaciju.";
const OG_IMAGE = "/img/infokarta-logo.jpg";

const OG_LOCALE = { hr: "hr_HR", en: "en_US", de: "de_DE" };

export const Seo = ({ title, description, path = "", image }) => {
  const { i18n } = useTranslation();
  const lang = i18n.resolvedLanguage || i18n.language || "hr";
  const fullTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const url = `${SITE_URL}${path || ""}`;
  const img = /^https?:\/\//i.test(image || "") ? image : `${SITE_URL}${image || OG_IMAGE}`;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:locale" content={OG_LOCALE[lang] || "hr_HR"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};
